export default "__VITE_ASSET__CA5Vs_X0__"